import type { T_ApprovalAlias } from "src/components/approvals/types"

const vehicleIncidentsStatusAliases: T_ApprovalAlias = {
    6: { StatusName: "Forwarded", ActionName: "Forwarded the Incident" },
    2: { StatusName: "Disciplined", ActionName: "Created Discipline" },
}

export default vehicleIncidentsStatusAliases